import { Check } from 'lucide-react'

export default function MultiSelectGrid({ options, selected, onToggle, max, counterTemplate }) {
  const counter = counterTemplate?.replace('{n}', selected.length) || `${selected.length} / ${max}`
  return (
    <div className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-2">
        {options.map(opt => {
          const isSelected = selected.includes(opt)
          const disabled = !isSelected && selected.length >= max
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onToggle(opt)}
              disabled={disabled}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition
                ${isSelected
                  ? 'bg-teal text-white border-teal shadow-card'
                  : 'bg-white border-teal-100 hover:border-teal-300 hover:bg-teal-50/60'}
                ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
            >
              <span className={`w-5 h-5 rounded-md border-2 grid place-items-center shrink-0
                ${isSelected ? 'border-white bg-white' : 'border-teal-300'}`}>
                {isSelected && <Check size={14} className="text-teal" strokeWidth={3} />}
              </span>
              <span className="text-sm font-medium">{opt}</span>
            </button>
          )
        })}
      </div>
      <div className="text-right text-sm text-ink-soft font-medium">
        {counter}
      </div>
    </div>
  )
}
